import { p as proxyCustomElement, H, h, c as Host } from './p-0498a6af.js';
import { i as inheritAriaAttributes, n as nanoid, c as clsx } from './p-70e482d1.js';

const stylesCss = ":host{display:inline-block}:host svg{display:block;width:1em;height:1em;fill:currentColor}:host(.size-2xl){font-size:var(--bi-icon-2xl) !important}:host(.size-xl){font-size:var(--bi-icon-xl) !important}:host(.size-large){font-size:var(--bi-icon-large) !important}:host(.size-medium){font-size:var(--bi-icon-medium) !important}:host(.size-small){font-size:var(--bi-icon-small) !important}:host(.color-inherit){color:inherit}:host(.color-primary){color:#01417b}:host(.color-gray){color:#1c1b1b}:host(.color-black){color:var(--bi-basic-key)}:host(.color-white){color:var(--bi-basic-white)}";
const BiIconCreditCardStyle0 = stylesCss;

const BiIconCreditCard$1 = /*@__PURE__*/ proxyCustomElement(class BiIconCreditCard extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.inheritedAttributes = {};
        this.titleText = null;
        /**
         * The color of the icon.
         * @default 'inherit'
         */
        this.color = 'inherit';
    }
    componentWillLoad() {
        this.inheritedAttributes = inheritAriaAttributes(this.el);
        this.titleText = this.el.getAttribute('title');
        if (this.titleText) {
            this.titleId = `title-${nanoid()}`;
        }
    }
    render() {
        return (h(Host, { key: '82ba7cf39d8f9f88583ca7ffa8773e45ab72d32f', class: clsx(`color-${this.color}`, this.size && `size-${this.size}`) }, h("svg", { key: '764c2e0d8efdccd834b442b9ed2fe570241d0733', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 -960 960 960', focusable: 'false', role: 'img', width: '1em', height: '1em', fill: 'currentColor', "aria-labelledby": this.titleId, ...this.inheritedAttributes }, this.titleText ? h("title", { id: this.titleId }, this.titleText) : null, h("path", { key: 'f4e90d8612ee1763eb986f1f464c1e659bfaac6f', d: 'M860-707.69v455.38Q860-222 839-201t-51.31 21H172.31Q142-180 121-201t-21-51.31v-455.38Q100-738 121-759t51.31-21h615.38Q818-780 839-759t21 51.31m-700 83.85h640v-83.85q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H172.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46zm0 127.68v243.85q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h615.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46v-243.85zM160-240v-480z' }))));
    }
    get el() { return this; }
    static get style() { return BiIconCreditCardStyle0; }
}, [1, "bi-icon-credit-card", {
        "size": [513],
        "color": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bi-icon-credit-card"];
    components.forEach(tagName => { switch (tagName) {
        case "bi-icon-credit-card":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BiIconCreditCard$1);
            }
            break;
    } });
}

const BiIconCreditCard = BiIconCreditCard$1;
const defineCustomElement = defineCustomElement$1;

export { BiIconCreditCard, defineCustomElement };
